export const CART_ENDPOINTS = {
  GET_CART: '/cart/',
  ADD_ITEM: '/cart/',
  CLEAR_CART: '/cart/',
  ITEM_DETAILS: (itemId: number | string) => `/cart/${itemId}/`,
  REMOVE_ITEM: (itemId: number | string) => `/cart/${itemId}/`,
  INCREMENT_ITEM: (itemId: number | string) => `/cart/${itemId}/increment/`,
  DECREMENT_ITEM: (itemId: number | string) => `/cart/${itemId}/decrement/`,
  CHECK_ALL: '/cart/checkall/',
  UNCHECK_ALL: '/cart/uncheckall/',
  CHECK_ITEM: (itemId: number | string) => `/cart/${itemId}/check/`,
  UNCHECK_ITEM: (itemId: number | string) => `/cart/${itemId}/uncheck/`,
}
